var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noData)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('noData')))]):_vm._e(),_c('AutoRow',{attrs:{"data":[
    {
      text: '用户数',
      value: _vm.data.users_count,
      to: { name: 'users.index' },
    }, {
      text: '占位',
      value: _vm.data.users_count,
      to: { name: 'users.index' },
    }, {
      text: '占位',
      value: _vm.data.users_count,
      to: { name: 'users.index' },
    }
  ]}}),_c('AutoChartRow',{attrs:{"data":[
    {
      text: '新增趋势折线图',
      options: _vm.newUsersTrendLineOptions,
    }, {
      text: '新增趋势柱状图',
      options: _vm.newUsersTrendBarOptions,
    }
  ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }